import React from 'react';

export default function ImageFrame({
  src,
  alt,
  caption,
  className = ''
}) {
  return (
    <div className={className}>
      <div className="rounded-xl ring-1 ring-neutral-800/50 bg-neutral-950 shadow-lg overflow-hidden">
        <img
          src={src}
          alt={alt}
          className="w-full h-auto"
          loading="lazy"
        />
      </div>
      {caption && (
        <p className="text-center text-neutral-500 mt-3 text-sm">
          {caption}
        </p>
      )}
    </div>
  );
}
